var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("a-modal", {
    attrs: {
      title: _vm.$t("模板预览"),
      visible: _vm.dialogVisible,
      footer: null,
      width: 620
    },
    on: {
      cancel: () => {
        _vm.$emit("cancel");
      }
    }
  }, [_vm.linkType == "NEW_LINK" ? _c("preview", {
    attrs: {
      customerInsuranceId: _vm.customerInsuranceId,
      insuranceId: _vm.insuranceId,
      templateControlsGroupId: _vm.templateControlsGroupId
    }
  }) : _vm.linkType == "COMPLETE" ? _c("div", {
    staticClass: "contBox"
  }, [_c("div", {
    staticClass: "phoneBox"
  }, [_vm.insureLink ? _c("iframe", {
    attrs: {
      src: _vm.insureLink,
      width: "100%",
      height: "100%"
    }
  }) : _vm._e()])]) : _vm._e()], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };